<template>
  <div>
    <div class="modal fade" tabindex="-1" :class="{ show: showModal }">
      <div class="modal-dialog">
        <div class="modal-content">
          <templatsListModal :selectedArtboard="selectedArtboard"
            v-if="showTemplatesModal == true"
            @close-templates-modal="showTemplatesModal = false"
          />
          <JewishDatePickerStart v-if="!isGregorianDisplay && showJewishDatePickerStart" @select-date="selectDisplayStartDate"
            @close-date-picker-modal="showJewishDatePickerStart = false" />
          <JewishDatePickerStartEnd v-if="!isGregorianDisplay && showJewishDatePickerEnd" @select-date="selectDisplayEndDate"
            @close-date-picker-modal="showJewishDatePickerEnd = false" />
          <div class="modal-header">
            <h6 class="modal-title">Add Donation</h6>
            <button
              type="button"
              class="btn btn-light"
              style="float: right; padding-bottom: 0px"
              @click="closeModal()"
              aria-label="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
          <Form class="form" @submit="addDonation">
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="screenArtboardId"
                      >Artboard <span class="required-field">*</span></label
                    >
                    <select
                      v-model="addDonationObj.screenArtboardId"
                      class="form-control"
                      rules="required"
                      disabled
                    >
                      <template
                        v-bind:key="index"
                        v-for="(artboard, index) in [selectedArtboard]"
                      >
                        <option :value="artboard.id">
                          {{ artboard.id }}
                        </option>
                      </template>
                    </select>
                    <ErrorMessage name="status" class="form-text text-danger" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="template"
                      >Template <span class="required-field">*</span></label
                    > <span v-on:click="showTemplatesModal = true" class="badge badge-btn">Templates</span>
                    <select
                      v-model="addDonationObj.templateId"
                      class="form-control"
                      rules="required"
                    >
                      <template
                        v-bind:key="index"
                        v-for="(template, index) in templates"
                      >
                        <option :value="template.id">
                          {{ template.name }}
                        </option>
                      </template>
                    </select>
                    <ErrorMessage name="status" class="form-text text-danger" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label for="title"
                    >Title <span class="required-field">*</span></label
                  >
                  <Field
                    id="title"
                    v-model="addDonationObj.title"
                    :rules="{
                      required: ['Title'],
                    }"
                    type="text"
                    name="title"
                    class="form-control shadow-none"
                    placeholder=""
                  />
                  <ErrorMessage
                    name="title"
                    class="form-text text-danger"
                  />
                </div>
                <div class="col-6 form-group">
                  <label for="name"
                    >Name <span class="required-field">*</span></label
                  >
                  <Field v-slot="{ field }" v-model="addDonationObj.name"
                      name="name" class="form-control">
                      <textarea v-bind="field" name="name" class="form-control"
                          rows="1" placeholder="" />
                      <ErrorMessage name="name" class="form-text text-danger" />
                  </Field>
                  <!-- <Field
                    id="name"
                    v-model="addDonationObj.name"
                    :rules="{
                      required: ['Name'],
                    }"
                    type="text"
                    name="name"
                    class="form-control shadow-none"
                    placeholder=""
                  />
                  <ErrorMessage
                    name="name"
                    class="form-text text-danger"
                  /> -->
                </div>
              </div>
              <div class="form-group">
                <label for="inHonorOf"
                  >In Honor <span class="required-field">*</span></label
                >
                <Field v-slot="{ field }" v-model="addDonationObj.inHonorOf"
                    name="inHonorOf" class="form-control">
                    <textarea v-bind="field" name="inHonorOf" class="form-control"
                        rows="1" placeholder="" />
                    <ErrorMessage name="inHonorOf" class="form-text text-danger" />
                </Field>
                <!-- <Field
                  id="inHonorOf"
                  v-model="addDonationObj.inHonorOf"
                  :rules="{
                    required: ['In Honor'],
                  }"
                  type="text"
                  name="inHonorOf"
                  class="form-control shadow-none"
                  placeholder=""
                />
                <ErrorMessage
                  name="inHonorOf"
                  class="form-text text-danger"
                /> -->
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label for="displayStartDate">Display Start Date & Time <span class="required-field">*</span></label>
                    <Field v-if="isGregorianDisplay" v-model="addDonationObj.displayStartDate"
                      rules="required" as="AppDateInput" name="displayStartDate"
                      class="form-control" id="displayStartDate"
                      placeholder="Display Start Date" />
                    <div v-else v-on:click="showJewishDatePickerStart = true" class="row date-picker-row">
                      <div class="col-10">
                        <Field v-model="displayStartHebrewDate" rules="required"
                          disabled type="text" name="displayStartDate"
                          class="form-control" id="displayStartDate"
                          placeholder="Display Start Date" />
                      </div>
                      <div class="col-2">
                          <i class="pi pi-calendar-plus text-primary"></i>
                      </div>
                    </div>
                    <ErrorMessage name="displayStartDate" class="form-text text-danger" />
                    <div class="row time-picker-row">
                      <div class="col-10">
                        <input v-model="displayStartTime" @change="updateStartTime" type="time" class="form-control" id="displayStartTime" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="displayEndDateOption"
                      >Time </label
                    >
                    <select
                      v-model="displayEndDateOption"
                      class="form-control"
                      name="displayEndDateOption"
                    >
                      <template
                        v-bind:key="index"
                        v-for="(option, index) in ['A week after', 'Half a month After', 'Month later']"
                      >
                        <option :value="option">
                          {{ option }}
                        </option>
                      </template>
                    </select>
                    <ErrorMessage name="displayEndDateOption" class="form-text text-danger" />
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="displayEndDate">Display End Date & Time <span class="required-field">*</span></label>
                    <Field v-if="isGregorianDisplay" v-model="addDonationObj.displayEndDate"
                      rules="required" as="AppDateInput" name="displayEndDate"
                      class="form-control" id="displayEndDate"
                      placeholder="Display End Date" />
                    <div v-else v-on:click="showJewishDatePickerEnd = true" class="row date-picker-row">
                      <div class="col-10">
                        <Field v-model="displayEndHebrewDate" rules="required"
                          disabled type="text" name="displayEndDate"
                          class="form-control" id="displayEndDate"
                          placeholder="Display End Date" />
                      </div>
                      <div class="col-2">
                          <i class="pi pi-calendar-plus text-primary"></i>
                      </div>
                    </div>
                    <ErrorMessage name="displayEndDate" class="form-text text-danger" />
                    <div class="row time-picker-row">
                      <div class="col-10">
                        <input v-model="displayEndTime" @change="updateEndTime" type="time" class="form-control" id="displayEndTime" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
                  class="artboard-box"
                  :style="getArtboardStyle()"
                >
                  <div>{{ selectedArtboard.content }}</div>
              </div> -->
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-custom-primary"
                :disabled="donationIsLoading ? true : false"
              >
                <span
                  v-if="donationIsLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span v-if="!donationIsLoading">Save</span>
              </button>
              <button type="button" class="btn btn-custom-secondary" @click="closeModal()">
                Close
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import templatsListModal from '@/components/template/Templates_Modal.vue';
import JewishDatePickerStart from '@/components/Jewish_Date_Picker.vue';
import JewishDatePickerStartEnd from '@/components/Jewish_Date_Picker.vue';

import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import { GET_TEMPLATES, REGISTER_DONATION } from '@/store/action_types';
import { DONATIONS_ROUTE } from '@/router/routes';

defineRule('required', (value, [fieldName = 'Field']) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});

export default {
  props: {
    selectedScreen: {
      type: Object,
      required: true,
    },
    selectedArtboard: {
      type: Object,
      required: true,
    },
    imageWidth: {
      type: String,
      required: true,
    },
    imageHeight: {
      type: String,
      required: true,
    },
    selectedDonation: {
      type: Object,
      required: false
    }
  },
  components: {
    Field,
    Form,
    ErrorMessage,
    templatsListModal,
    JewishDatePickerStart,
    JewishDatePickerStartEnd,
  },
  data() {
    const now = new Date();
    const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`; // Local time in HH:mm format

    return {
      showModal: true,
      showTemplatesModal: false,
      showJewishDatePickerStart: false,
      showJewishDatePickerEnd: false,
      addDonationObj: {
        title: null,
        name: null,
        inHonorOf: null,
        displayStartDate: null,
        displayEndDate: null,
        screenId: null,
        screenArtboardId: null,
        templateId: null,
        organizationId: null,
      },
      displayStartHebrewDate: null,
      displayEndHebrewDate: null,
      displayStartTime: currentTime, // Default to current local time
      displayEndTime: currentTime,   // Default to current local time
      displayEndDateOption: null
    };
  },
  watch: {
    displayEndDateOption(newVal) {
      // Start from the current start date or now
      let baseDate = this.addDonationObj.displayStartDate
        ? new Date(this.addDonationObj.displayStartDate)
        : new Date();

      // Add the appropriate amount of time
      if (newVal === 'A week after') {
        baseDate.setDate(baseDate.getDate() + 7);
      } else if (newVal === 'Half a month After') {
        baseDate.setDate(baseDate.getDate() + 15);
      } else if (newVal === 'Month later') {
        baseDate.setMonth(baseDate.getMonth() + 1);
      }

      this.displayEndHebrewDate = this.$filters.convertToHebrewDate(baseDate);
      this.addDonationObj.displayEndDate = this.applyTimeToValue(baseDate, this.displayEndTime || '00:00');
    }
  },
  computed: {
    donation() {
      return this.$store.getters.donation.data;
    },
    donationIsLoading() {
      return this.$store.getters.donation.isLoading;
    },
    templates() {
      return this.$store.getters.templates.data;
    },
    templatesIsLoading() {
      return this.$store.getters.templates.isLoading;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    getTimeInputValue(dateValue) {
      if (!dateValue) return null;
      const isoValue = typeof dateValue === 'string' ? dateValue : String(dateValue);
      const match = isoValue.match(/T(\d{2}):(\d{2})/);
      return match ? `${match[1]}:${match[2]}` : null;
    },
    getDatePart(dateValue) {
      if (!dateValue) return null;
      if (typeof dateValue === 'string') {
        const match = dateValue.match(/^(\d{4}-\d{2}-\d{2})/);
        if (match) return match[1];
      }

      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) return null;
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    getOffsetSuffix(offsetMinutes) {
      const total = Number(offsetMinutes);
      if (!Number.isFinite(total)) return 'Z';

      const sign = total >= 0 ? '+' : '-';
      const abs = Math.abs(total);
      const hours = String(Math.floor(abs / 60)).padStart(2, '0');
      const minutes = String(abs % 60).padStart(2, '0');
      return `${sign}${hours}:${minutes}`;
    },
    applyTimeToValue(dateValue, timeValue) {
      if (!dateValue || !timeValue) return dateValue;
      const datePart = this.getDatePart(dateValue);
      if (!datePart) return dateValue;
      return `${datePart}T${timeValue}:00.000${this.getOffsetSuffix(this.addDonationObj.offset)}`;
    },
    setValues() {
      if(this.selectedDonation) {
        this.addDonationObj.title = this.selectedDonation.title;
        this.addDonationObj.name = this.selectedDonation.name;
        this.addDonationObj.inHonorOf = this.selectedDonation.inHonorOf;
        this.addDonationObj.templateId = this.selectedDonation.templateId;

        if (this.selectedDonation.displayStartDate) {
          this.addDonationObj.displayStartDate = this.selectedDonation.displayStartDate;
          this.displayStartTime = this.getTimeInputValue(this.selectedDonation.displayStartDate);
        }

        if (this.selectedDonation.displayEndDate) {
          this.addDonationObj.displayEndDate = this.selectedDonation.displayEndDate;
          this.displayEndTime = this.getTimeInputValue(this.selectedDonation.displayEndDate);
        }

        this.displayStartHebrewDate = this.$filters.convertToHebrewDate(this.selectedDonation.displayStartDate)
        this.displayEndHebrewDate = this.$filters.convertToHebrewDate(this.selectedDonation.displayEndDate)

        this.addDonationObj.screenArtboardId = this.selectedArtboard.id
        this.addDonationObj.screenId = this.selectedScreen.id;
      } else {
        this.addDonationObj.screenArtboardId = this.selectedArtboard.id
        this.addDonationObj.screenId = this.selectedScreen.id;
      }

      this.addDonationObj.organizationId = this.account.organizationId;

      const offsetMinutes = -new Date().getTimezoneOffset();
      this.addDonationObj.offset = offsetMinutes;
    },
    closeModal() {
      this.$emit('closeAddDonationModal');
    },
    selectDisplayStartDate(selectedDate) {
      const date = this.$filters.convertHDateToGregorian(selectedDate);
      this.displayStartHebrewDate = this.$filters.convertToHebrewDate(date);
      this.updateStartDate(date);
    },
    selectDisplayEndDate(selectedDate) {
      const date = this.$filters.convertHDateToGregorian(selectedDate);
      this.displayEndHebrewDate = this.$filters.convertToHebrewDate(date);
      this.updateEndDate(date);
    },
    updateStartDate(date) {
      this.addDonationObj.displayStartDate = this.applyTimeToValue(date, this.displayStartTime || '00:00');
    },
    updateEndDate(date) {
      this.addDonationObj.displayEndDate = this.applyTimeToValue(date, this.displayEndTime || '00:00');
    },
    updateStartTime() {
      if(!this.addDonationObj.displayStartDate) {
        this.$toast.info('Please select a start date first')
        return
      }

      this.addDonationObj.displayStartDate = this.applyTimeToValue(
        this.addDonationObj.displayStartDate,
        this.displayStartTime
      );
    },
    updateEndTime() {
      if(!this.addDonationObj.displayEndDate) {
        this.$toast.info('Please select an end date first')
        return
      }

      this.addDonationObj.displayEndDate = this.applyTimeToValue(
        this.addDonationObj.displayEndDate,
        this.displayEndTime
      );

    },
    
    getTemplates() {
      this.$store.dispatch(GET_TEMPLATES, { organizationId: this.account.organizationId });
    },
    addDonation() {
      if (this.addDonationObj.displayStartDate && this.displayStartTime) {
        this.addDonationObj.displayStartDate = this.applyTimeToValue(
          this.addDonationObj.displayStartDate,
          this.displayStartTime
        );
      }

      if (this.addDonationObj.displayEndDate && this.displayEndTime) {
        this.addDonationObj.displayEndDate = this.applyTimeToValue(
          this.addDonationObj.displayEndDate,
          this.displayEndTime
        );
      }

      this.$store
        .dispatch(REGISTER_DONATION, this.addDonationObj)
        .then((res) => {
          if (res) {
            if(this.selectedDonation) this.$router.push({ name: DONATIONS_ROUTE })

            this.closeModal();
            this.$emit('refreshScreen');
          }
        });
    },
  },
  mounted() {
    this.setValues();
    this.getTemplates();
  },
};
</script>
<style scoped>
.modal-content {
  border-radius: 20px !important;
  border: 1px solid transparent;
  background-color: #fdfdfe !important;
  max-height: 92vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  display: none;
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 50%;
}

.modal {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.modal-content {
  border: 1px solid #e4e4e7;
}

.modal-header {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid #e4e4e7;
}

.modal-header .modal-title {
  position: relative;
  top: 8px;
  font-size: 1.1rem;
}

.image-container {
  position: relative;
  display: inline-block;
  margin-top: 1rem;
}

.artboard-box {
  box-sizing: border-box;
}

.modal-footer {
  border-top: 1px solid #e4e4e7;
}

.time-picker-row {
  margin-top: 10px;
}

textarea {
  height: 45px !important;
}

@media (min-width: 1000px) {
  .modal-dialog {
    max-width: 50%;
  }
}
</style>
